import React from 'react';

/**
 * LiveBadge — red highlight + white "LIVE" indicator for true-live events.
 * Shown on hero + swimlane cards only when the event is actually live.
 *
 * Variants:
 *   - "full" (default): red pill with a pulsing dot + "LIVE" text
 *   - "compact": just a pulsing red recording dot (for small cards / tight space)
 */
const LiveBadge = ({ variant = 'full', className = '' }) => {
  if (variant === 'compact') {
    return (
      <span
        className={`inline-flex items-center justify-center ${className}`}
        role="img"
        aria-label="Live"
        title="Live"
      >
        <span className="w-2.5 h-2.5 bg-red-600 rounded-full animate-pulse ring-2 ring-white/70" />
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-1 bg-red-600 text-white text-xs font-bold uppercase tracking-wide px-2 py-0.5 rounded ${className}`}
    >
      <span className="w-1.5 h-1.5 bg-white rounded-full animate-pulse" />
      Live
    </span>
  );
};

export default LiveBadge;
